import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommunicationService } from '../communication.service';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { EventDetail } from '../model/event-detail.model';

import { CrawfordSnackbarService, DateFormat } from 'crawford-shell';

import { global } from '../../app.settings';
import { DatePipe } from '@angular/common';
import { DocumentDownloadComponent } from '../document-download/document-download.component';
import { DocumentDownload } from '../model/document-download.model';

@Component({
  selector: 'app-event-detail',
  templateUrl: './event-detail.component.html',
  styleUrls: ['./event-detail.component.scss']
})
export class EventDetailComponent implements OnInit {

  private _eventDetails: EventDetail;
  private datePipe = new DatePipe(navigator.language);
  private dateFormat = global.dateTimeFormat;

  @ViewChild('documentDownload') documentDownload: DocumentDownloadComponent;

  @Input() public crawfordRef: string;
  @Input() set eventDetails(value: EventDetail) {
    this._eventDetails = value;

    if (this.eventDetails) {
      this.setFormValues();
    }
  }

  get eventDetails(): EventDetail {
    return this._eventDetails;
  }

  public eventId: number;
  public eventDetailsForm: FormGroup;

  constructor(private activatedRoute: ActivatedRoute,
              private commsService: CommunicationService,
              private formBuilder: FormBuilder,
              public snackbarService: CrawfordSnackbarService,
  ) {
    this.createEventDetailsForm();
  }

  ngOnInit() {
  }

  private createEventDetailsForm(): any {
    this.eventDetailsForm = this.formBuilder.group({
      EventDateTime: new FormControl(),
      EventParty: new FormControl(),
      EventType: new FormControl(),
      EventCategory: new FormControl(),
    });

    this.eventDetailsForm.disable();
  }

  private setFormValues(): any {
    this.eventDetailsForm.reset({
      EventDateTime: this.datePipe.transform(this._eventDetails.date, this.dateFormat),
      EventParty: this._eventDetails.party,
      EventType: this._eventDetails.name,
      EventCategory: this._eventDetails.category,
    });

    const document: DocumentDownload = {
      id: this._eventDetails.id,
      name: this._eventDetails.documentName,
      icon: this._eventDetails.iconClass
    };

    this.documentDownload.details = document;
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/communication/event-detail/event-detail.component.ts